import { Navigate, Outlet } from 'react-router-dom';
const AuthRedirect = () => {
  const isAuthenticated = !!localStorage.getItem('accessToken');

  if (isAuthenticated) {
    // Redirect to home or dashboard if already authenticated
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default AuthRedirect;